"use strict";

exports.__esModule = true;
exports.checkboxRenderer = exports.RENDERER_TYPE = void 0;
var _checkboxRenderer = require("./checkboxRenderer");
exports.RENDERER_TYPE = _checkboxRenderer.RENDERER_TYPE;
exports.checkboxRenderer = _checkboxRenderer.checkboxRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/checkboxRenderer/index.js
// module id = 569
// module chunks = 0